export default "__VITE_ASSET__C_lT$vRy__"